<template>
  <div class="step1Manager">
    <div class="title clearfix">
      <p class="type pull-left type-title">入驻类型</p>
      <el-tag
        class="type-tag"
        effect="dark"
        size="mini"
        :type="title === '新设' ? '' : title === '迁入' ? 'warning' : 'success'"
        >{{ title }}</el-tag
      >
      <div class="type-line"></div>
      <div class="type-time">填报时间：{{ date }}</div>
    </div>
    <div style="display: flex; align-item: center; margin-bottom: 20px">
      <p class="type pull-left type-title2">入驻小镇:</p>
      <el-select
        v-model="tableData.ftCode"
        placeholder="请选择"
        :disabled="true"
      >
        <el-option
          v-for="options in TownList"
          :key="options.value"
          :label="options.label"
          :value="options.value"
        >
        </el-option>
      </el-select>
    </div>
    <table-form
      :dataSource="dataSource"
      :tableData="tableData"
      ref="form"
    ></table-form>
    <div class="footerBtn">
      <el-button @click="toList">上一步</el-button>
      <el-button class="mainBtn" @click="DoDebounce(save, 'timer1')"
        >保存</el-button
      >
      <el-button class="mainBtn" @click="DoDebounce(saveBeforeNext, 'timer2')"
        >保存并下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import TableForm from "common/components/form/tableForm";
import { newStep1 } from "@/conf/Agency";
import comMixin from "common/js/mixin/comMixin";
import { debounce } from "common/js/tools.js";
import {
  nation,
  selectDic,
  addUpAgency,
  getDetailAgency,
  getTownBaiscList,
  initReport,
} from "common/js/api";
import { mapState, mapMutations } from "vuex";

export default {
  props: ["title"],

  components: {
    TableForm,
  },

  mixins: [comMixin],
  data() {
    return {
      dataSource: [],
      route: "",
      userCode: "",
      institutionName: "",
      tableData: {},
      codeId: "",
      step: 0,
      TownList: [],
      ftCode: "",
      type: "",
      date: "",
      timer: {},
    };
  },

  created() {
    this.date = this.getDate();
    this.$forceUpdate();
    this.userCode = this.Cookies.get("identifyCode");
    this.$nextTick(() => {
      this.dataSource = this.$lodash.cloneDeep(newStep1);
    });

    let selectFtCode = this.Cookies.get("preFtCode");
    if (typeof selectFtCode != "undefined") {
      console.log("找到preFtCode", selectFtCode);
      this.tableData.ftCode = selectFtCode;
    } else {
      selectFtCode = this.Cookies.get("ftCode");
      if (typeof selectFtCode != "undefined") {
        console.log("使用ftCode", selectFtCode);

        this.tableData.ftCode = selectFtCode;
      } else console.log("preFtCode和ftCode都没有");
    }

    // this.getType();
    this.enterType = this.$route.query.flag == "new" ? 0 : 1;
  },

  mounted() {
    this.getSelect();
    //this.getNation();
    this.getUpdateData();
    this.getTownList();
  },

  methods: {
    getDate() {
      let year = new Date().getFullYear(); //年
      let month = new Date().getMonth() + 1; //注意！月份是从0月开始获取的，所以要+1;
      let day = new Date().getDate(); //日
      const todayDate =
        year +
        "-" +
        (month >= 10 ? month : "0" + month) +
        "-" +
        (day >= 10 ? day : "0" + day);
      return todayDate;
    },
    DoDebounce(func, timer) {
      debounce(func, 2000, timer, true);
    },
    saveBeforeNext() {
      if (!this.tableData.ftCode || this.tableData.ftCode == "") {
        if (this.Cookies.get("ftCode")) {
          if (this.Cookies.get("ftCode") != "") {
            this.$refs.form.form.ftCode = this.Cookies.get("ftCode");
          } else {
            this.$refs.form.form.ftCode = "c2023992ae4b4bed9a8786dfc02838fc";
          }
        } else this.$refs.form.form.ftCode = "c2023992ae4b4bed9a8786dfc02838fc";
      } else this.$refs.form.form.ftCode = this.tableData.ftCode;
      console.log("log4", this.$refs.form.form.institutionCode);
      this.save().then((res) => {
        if (res == true) {
          console.log("保存成功", res);
          this.$emit("next");
        } else console.log("保存失败", res);
      });
    },
    /* setRegiste(val) {
      const need = this.dataSource.find(
        (item) => item.field == "associationRegisteFinished"
      );
      if (val === true) {
        if (!need) {
          this.dataSource.splice(7, 0, {
            label: "是否完成中国证券投资基金业协会登记/备案",
            formtype: "select",
            options: [
              {
                label: "是",
                value: true,
              },
              {
                label: "否",
                value: false,
              },
            ],
            field: "associationRegisteFinished",
            require: false,
          });
        }
      } else {
        if (need) {
          this.dataSource.splice(7, 1);
        }
      }
    }, */
    async getTownList() {
      const { result } = await getTownBaiscList();
      // console.log(result);
      // if (this.title != "新设") {
      //   // this.selectClassEnd = result[0].fundTownName;
      // } else {
      //   // this.selectClassEnd = "未选中";
      result.forEach((item) => {
        let data = {
          label: item.fundTownName,
          value: item.fundTownCode,
        };
        // console.log(item);
        this.TownList.push(data);
      });
      // }
      // this.TownList = this.dataSource[12].options;
    },
    // selectClass(event) {
    //   this.$refs.form.form.ftCode = event.target.value;
    // },

    async getSelect() {
      const query = "2,4,5,11";
      const result = await selectDic(query);
      const {
        //FUND_INSTITUTION_ORIGIN,
        //FUND_PRODUCT_TYPE,
        INVEST_INDUSTRY,
        FUND_TYPE,
      } = result.result;

      //this.converSelect(FUND_INSTITUTION_ORIGIN, 11);
      //this.converSelect(FUND_PRODUCT_TYPE, 3);
      // this.converSelect(FUND_TYPE, 6);
      // this.converSelect(INVEST_INDUSTRY, 9);
    },

    async getNation() {
      const query = 0;
      const result = await nation(query);
      result.result.forEach((item) => {
        let data = {
          label: item.district,
          value: item.district,
        };
        //this.dataSource[12].options.push(data);
      });
    },

    converSelect(option, index) {
      option.forEach((item) => {
        let data = {
          label: item,
          value: item,
        };
        this.dataSource[index].options.push(data);
      });
    },

    async save() {
      const isValidate = this.$refs.form.submitForm();
      this.Cookies.set("fundBasic", this.$refs.form.form);
      this.Cookies.set("fundType", this.$refs.form.form.fundType);
      this.Cookies.set("institutionName", this.$refs.form.form.institutionName);

      if (!isValidate) return false;
      const res = await this.submit(this.$refs.form.form);
      console.log("res:", res);
      if (res == true) {
        console.log("保存成功");
        this.$message({
          message: "保存成功!",
          type: "success",
        });
        return true;
      }
    },

    async submit(form) {
      console.log("log5", this.$refs.form.form.institutionCode);
      this.Cookies.set("ftCode", this.$refs.form.form.ftCode);
      this.Cookies.set("selectedBasicFtCode", this.tableData.ftCode);
      form.userInstitutionCode = this.userCode;
      form.enterType = this.enterType;
      form.ftCode = this.tableData.ftCode;
      if (Array.isArray(form.investDirection)) {
        form.investDirection = form.investDirection.join(",");
      }
      let flag = this.$route.query.edit || this.$route.query.flag;
      // 变更
      if (flag == "update") {
        form.institutionCode = this.$route.query.codeId || "";
      }
      if (typeof form.institutionCode != "undefined") {
        console.log("第二次点击save了，我有code了");
        flag = "update";
      }
      console.log("log6", this.$refs.form.form.institutionCode);
      const result = await addUpAgency(flag, form);
      console.log("log7", result);
      console.log("log8", flag);
      if (flag != "update") {
        this.$refs.form.form.institutionCode = result.result;
        this.$route.query.codeId = result.result;
      }
      if (this.$refs.form.form.investDirection) {
        this.$refs.form.form.investDirection = this.$refs.form.form.investDirection.split(
          ",",
        );
      }

      if (result.message == "EXISTED") {
        this.$message({
          message: "当前企业已经入驻,不能重复入驻!",
          type: "warning",
        });
        return false;
      }
      if (result.message == "003") {
        this.$message({
          message:
            "注册为基金管理类型入驻基金机构，入驻基金机构名称不能与注册机构名称相同!",
          type: "warning",
        });
        return false;
      }

      if (flag == "update") {
        this.codeId = this.$route.query.codeId;
      } else {
        this.codeId = result.result;
      }
      this.Cookies.set("fundBasic", this.$refs.form.form);
      this.Cookies.set("fundType", this.$refs.form.form.fundType);
      this.Cookies.set("institutionName", this.$refs.form.form.institutionName);

      this.Cookies.set("capitalAdmitted", this.$refs.form.form.capitalAdmitted);

      return true;
    },

    async getUpdateData() {
      let flag = this.$route.query.edit || this.$route.query.flag;
      const codeId = this.$route.query.codeId;
      if (flag != "update") return;
      const res = await getDetailAgency(codeId);

      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      this.tableData = res.result.basic;
      this.tableData.registeIs = this.tableData.registeIs ? "1" : "0";
      this.tableData.autoManaged = this.tableData.autoManaged ? "1" : "0";
      this.tableData.associationRegisteFinished = this.tableData
        .associationRegisteFinished
        ? "1"
        : "0";
      //this.tableData.officeNeed = this.tableData.officeNeed === false ? "否" : "是";
      // this.tableData.associationRegisteFinished = this.tableData.associationRegisteFinished === false ? "否" : "是"
      if (this.tableData) {
        if (this.tableData.investDirection) {
          this.tableData.investDirection = this.tableData.investDirection.split(
            ",",
          );
        }
      }
      /*  setTimeout(() => {
        this.setRegiste(this.tableData.associationRegiste);
      }, 500); */
    },

    // 基金机构的名字是唯一的 如果基金管理用户 填写基金机构 则可填写多个名字不唯一
    async getType() {
      const res = await initReport(this.userCode);
      this.type = res.result.institutionType;
      if (this.type == "JJ") {
        this.institutionName = this.Cookies.get("institutionName");
        this.tableData = {
          institutionName: this.institutionName,
        };
        this.dataSource[0].disabled = true;
      }
    },

    toList() {
      this.$router.push("/FundAgency/FundList");
    },
    ...mapMutations(["setMgrData"]),
  },

  computed: {
    ...mapState({
      mgrData(state) {
        return state.MgrData.mgrData;
      },
    }),
  },
  watch: {
    "$route.query": {
      handler(newval) {
        let item = this.dataSource.find((item) => {
          return item.field == "institutionName";
        });
        if (!item) return;
        if (newval.codeId && (!newval.checkState || newval.checkState < 3)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  margin: 0 0 20px 0px;
  font-size: 14px;
  color: #6c7885;
  display: flex;
  align-items: center;
}
</style>
